import { z } from "zod";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";
import { PropertyBankSchema } from "./ShowBankResponse";

export const CreateBankResponseSchema = BaseResponseSchema.extend({
    data: PropertyBankSchema,
})

export type CreateBankResponse = z.infer<typeof CreateBankResponseSchema>;